import React from 'react';
import { useTranslation } from 'react-i18next';
import Lottie from 'lottie-react';

import firewallAnimation from '../assets/lottie-firewall.json';
import moderationAnimation from '../assets/lottie-moderation.json';
import analyticsAnimation from '../assets/lottie-analytics.json';
import complianceAnimation from '../assets/lottie-compliance.json';

// Ícone de Check para a lista de benefícios
const CheckIcon = () => <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-accent flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>;

const Solutions = () => {
    const { t } = useTranslation();

    const services = [
        { animationData: firewallAnimation, titleKey: 'solutions_item1_title', bullets: ['solutions_item1_b1', 'solutions_item1_b2', 'solutions_item1_b3'] },
        { animationData: moderationAnimation, titleKey: 'solutions_item2_title', bullets: ['solutions_item2_b1', 'solutions_item2_b2', 'solutions_item2_b3'] },
        { animationData: analyticsAnimation, titleKey: 'solutions_item3_title', bullets: ['solutions_item3_b1', 'solutions_item3_b2', 'solutions_item3_b3'] },
        { animationData: complianceAnimation, titleKey: 'solutions_item4_title', bullets: ['solutions_item4_b1', 'solutions_item4_b2', 'solutions_item4_b3'] }
    ];

  return (
    <section id="solutions" className="py-20 bg-solution-light">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16" data-aos="fade-up">
            {/* Título com gradiente de texto para destaque */}
            <h2 className="text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary to-accent">
                {t('solutions_main_title')}
            </h2>
        </div>
        
        {/* Layout agora é uma coluna única, com cards largos */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {services.map((service, index) => (
                <div 
                  key={index} 
                  className="bg-white rounded-xl shadow-lg overflow-hidden transition-all duration-300 transform hover:shadow-2xl"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  {/* NOVA DIAGRAMAÇÃO LADO A LADO */}
                  <div className="grid grid-cols-1 md:grid-cols-2 items-center">
                    {/* Coluna da Animação */}
                    <div className={`h-64 flex items-center justify-center p-6 ${index % 2 === 0 ? 'md:order-1' : 'md:order-2'}`}>
                      <Lottie animationData={service.animationData} loop={true} style={{ height: '100%' }} />
                    </div>

                    {/* Coluna do Texto */}
                    <div className={`p-8 ${index % 2 === 0 ? 'md:order-2' : 'md:order-1'}`}>
                      <h3 className="text-2xl font-bold text-primary mb-4">{t(service.titleKey)}</h3>
                      {/* Lista de Benefícios */}
                      <ul className="space-y-3">
                        {service.bullets.map(bulletKey => (
                            <li key={bulletKey} className="flex items-center">
                                <CheckIcon />
                                <span className="text-gray-600 ml-3">{t(bulletKey)}</span>
                            </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
            ))}
        </div>
      </div>
    </section>
  );
}

export default Solutions;